<template>
    <div :class="[inputCssClass, errorMessages ? 'field-error' : '']">
        <div class="global-label">{{ fieldLabel }}</div>
        <div>
            <v-menu
                v-model="menuOpen"
                :transition="false"
                offset-y
                right
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ on }">
                    <div tabindex="0" class="disp cursor-pointer" v-on="on">
                        <div v-if="status" class="d-flex">
                            <div class="val ml-2 pr-1">{{ statusDisp }}</div>
                        </div>
                        <div v-else>
                            <div class="val ml-2" style="color: var(--v-n4-base);">
                                {{ emptyText }}
                            </div>
                            <div :class="['arrow', menuOpen ? 'arrow--open' : '']"><v-icon>mdi-menu-down</v-icon></div>
                        </div>
                    </div>
                </template>
                <v-card>
                    <v-list dense style="max-height: 500px; max-width: 273px; overflow: auto;">
                        <v-list-item
                            v-for="item in items"
                            :key="item.id"
                            style="min-height: 32px;"
                            @click="toggleSelection(item.code)"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-regular subtitle-2">
                                    {{ item.name }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon v-if="status === item.code" color="primary">check</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
            <div :class="['details', errorMessages ? 'error--text' : '']">
                {{ errorMessages }}
            </div>
        </div>
    </div>
</template>

<script>
import { computed, ref, watch } from "@vue/composition-api";
import useProjectInfo from "../../composables/use-project-info";
import ProjectModule from "@/store/modules/project";
import { $t } from "@/i18n";

export default {
    name: "ProjectStatusField",
    props: {
        label: {
            type: String,
            default: null
        },
        accountId: {
            type: Number,
            default: 0
        },
        value: {
            type: String,
            default: null
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: "task-field"
        },
        emptyText: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const { projectFields, setAccountId } = useProjectInfo(props.accountId);
        const { isEventTypeCompany } = ProjectModule()

        const menuOpen = ref(false);
        const status = ref(props.value);

        const accountId = computed(() => {
            return props.accountId;
        });
        const statusDisp = computed(() => {
            if (!status.value) return "";
            let item = items.value.find(x => x.code === status.value);
            return item == null ? status.value : item.name;
        });
        const fieldLabel = computed(() => {
            if (props.label != null) return props.label;
            return isEventTypeCompany(props.accountId) ? $t("Wait until event status") : $t("Wait until project status")
        });
        const items = computed(() => {
            let statusField = projectFields.value.find(x => x.name === "status");
            if (statusField == null || statusField._data == null || statusField._data.choices === undefined) return [];
            return statusField._data.choices;
        });

        const toggleSelection = (new_status) => {
            status.value = (status.value === new_status) ? null : new_status;
            menuOpen.value = false;
            ctx.emit("change", status.value);
        };

        watch(accountId, (val) => {
            setAccountId(val);
        });

        return {
            menuOpen,
            status,
            statusDisp,
            fieldLabel,
            items,
            toggleSelection
        };
    }
}
</script>
